<template>
  <section :class="$style.container" data-luko-tracking="TestimonialList">
    <Wrapper :class="$style.inner">
      <transition-group
        v-for="(columnItems, i) in largeScreenItems"
        :key="'lg-' + i"
        name="popping"
        tag="div"
        :class="$style.largeScreen"
      >
        <Card
          v-for="item in columnItems"
          :key="'lg-card-' + item.id"
          :class="$style.card"
          :item="item"
        />
      </transition-group>

      <transition-group
        v-for="(columnItems, i) in mediumScreenItems"
        :key="'md-' + i"
        name="popping"
        tag="div"
        :class="$style.mediumScreen"
      >
        <Card
          v-for="item in columnItems"
          :key="'md-card-' + item.id"
          :class="$style.card"
          :item="item"
        />
      </transition-group>

      <transition-group
        v-for="(columnItems, i) in smallScreenItems"
        :key="'sm-' + i"
        name="popping"
        tag="div"
        :class="$style.smallScreen"
      >
        <Card
          v-for="item in columnItems"
          :key="'sm-card-' + item.id"
          :class="$style.card"
          :item="item"
        />
      </transition-group>
    </Wrapper>
    <div :class="$style.seeMore">
      <ArrowButton v-if="hasSeeMore" is-outlined @click="onSeeMore">
        {{ slice.primary.see_more_button_text }}
      </ArrowButton>
    </div>
  </section>
</template>

<script>
import ArrowButton from '~/components/ArrowButton'

import Card from './components/Card'
const PAGE_LIMIT = 10

export default {
  name: 'TestimonialList',
  components: {
    Card,
    ArrowButton,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      required: true,
    },
  },

  data() {
    let i = 0
    return {
      items: this.slice.items.map((item) => {
        item.id = i++
        return item
      }),
      limit: PAGE_LIMIT,
    }
  },

  computed: {
    content() {
      return this.slice.primary
    },
    largeScreenItems() {
      return this.groupByColumns(this.items, 3)
    },
    mediumScreenItems() {
      return this.groupByColumns(this.items, 2)
    },
    smallScreenItems() {
      return this.groupByColumns(this.items, 1)
    },
    filterMap() {
      return this.badges.reduce((mapObj, badge) => {
        mapObj[badge.id] = badge.isSelected
        return mapObj
      }, {})
    },
    noneOfFilterSelected() {
      return !this.badges.some((badge) => badge.isSelected)
    },
    hasSeeMore() {
      return (
        this.items.filter(
          (item) => this.noneOfFilterSelected || this.isSelected(item.type)
        ).length > this.limit
      )
    },
  },

  watch: {
    filterMap() {
      // initiate page limit if badge filter changed
      this.limit = PAGE_LIMIT
    },
  },

  methods: {
    groupByColumns(items, nb_column) {
      const groupedItems = new Array(nb_column).fill(0).map(() => [])
      const copied_items = [...items]

      let i = 0
      let cnt = 0
      while (copied_items.length) {
        const _item = copied_items.shift()
        if (
          nb_column === 1 || // no filter applied on nb_colum 1 (mobile device)
          this.noneOfFilterSelected ||
          this.isSelected(_item.type)
        ) {
          groupedItems[i].push(_item)
          i = (i + 1) % nb_column
          cnt++
          if (cnt > this.limit) break
        }
      }
      return groupedItems
    },

    onSeeMore() {
      this.limit += PAGE_LIMIT
    },

    isSelected(type) {
      const key = Object.keys(this.filterMap).find((key) => key.includes(type))
      return this.filterMap[key]
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 83px 0 120px 0;
}

.inner {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  max-width: 1330px;
  margin: 0 auto;
  @include below(large) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 780px;
  }
  @include below(small) {
    grid-template-columns: repeat(1, 1fr);
  }
}
.card {
  margin-bottom: 40px;
}

.largeScreen {
  @include below(large) {
    display: none;
  }
}
.mediumScreen {
  @include below(small) {
    display: none;
  }
  @include above(large) {
    display: none;
  }
}
.smallScreen {
  @include above(small) {
    display: none;
  }
}

.seeMore {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}
</style>
<style lang="scss" scoped>
/* enter */
.popping-enter-from {
  transform: scale(0);
  opacity: 0;
}
.popping-enter-active {
  transform: scale(0);

  transition: all 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}
.popping-enter-to {
  transform: scale(1);
  opacity: 1;
}

/* leave */
.popping-leave-from {
  position: absolute;

  display: none;
}
.popping-leave-active {
  position: absolute;

  display: none;
}
.popping-leave-to {
  position: absolute;

  display: none;
}
</style>
